module.exports = __webpack_public_path__ + "img/1.1bad12c6.jpg";